<template>
  <v-app id="inspire">
    <v-toolbar color="blue-grey darken-4" dark fixed app>
      <v-toolbar-title>Adeton POS</v-toolbar-title>
      <v-spacer></v-spacer>

      <h3>(SALES)</h3>
      <v-btn icon @click="signout()">
        <v-icon>settings_power</v-icon>
      </v-btn>
    </v-toolbar>
    <v-main style="background:#8080802e">
      <v-container grid-list-md text-xs-center  class="fill-height">
        <router-view> </router-view>
      </v-container>
    </v-main>
    <v-footer color="black" app>
      <span class="white--text">&copy; GoPear Technologies (0506340523)</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    source: String,
  },
  created() {
    let c = this;
    // let info = this.$authman.getSession(function(err, response) {
    //     if (err) {
    //         console.log('network error')
    //     } else if (!response.userCtx.name) {
    //         console.log('no one is logged in')
    //     } else {
    //         // if (response.userCtx.roles.indexOf('_admin') > -1) {
    //         //     let userlink = {
    //         //         id: 6,
    //         //         icon: 'group',
    //         //         text: 'User Management',
    //         //         link: '/users'
    //         //     }

    //         //     c.routes.unshift(userlink)
    //         //         //console.log(' user is admin')
    //         // }

    //     }
    // });
  },
  methods: {
    signout() {
      var vm = this;

      this.$store.dispatch("Auth/logout");
      vm.$router.push("/");
    },
    setLayout(layout) {
      this.$store.dispatch("Layouts/set_layout", layout);
    },
    checkiflogout(link) {
      if (link == "/login") {
        this.setLayout("simple-layout");
      }
    },
  },
};
</script>